// src/atoms/auth.ts
import { atom } from 'recoil'

export interface DynamicOrder {
  roi: number
  size: number
}

// 서버 응답을 기준으로 필드 null 가능성 반영
export interface TradingInfo {
  id: number
  userId: number
  botStatus: number
  symbol: string
  leverage: number
  tp: number | null
  sl: number | null
  size: number
  direction: number
  // [] 도, null 도 들어올 수 있으므로 이렇게 허용
  dynamic: DynamicOrder[] | null
  roi: number | null
  addOrder: number
  currentAddOrder: number
  maxAddOrder: number
  currentAddOrderLong: number | null
  currentAddOrderShort: number | null
  createdAt: string
  // 서버에서 null인 경우가 있으니 null 허용
  updatedAt: string | null
  deletedAt: string | null
}

export interface SpotInfo {
  id: number
  userId: number
  botStatus: number
  symbol: string
  tp: number | null
  sl: number | null
  size: number
  dynamic: DynamicOrder[] // 필요하면 | null 로 바꿔도 됨
  roi: number | null
  addOrder: number
  currentAddOrder: number
  maxAddOrder: number
  createdAt: string
  updatedAt: string
  deletedAt: string | null
}

export interface AuthState {
  id: number | null
  account: string
  username: string
  nickname: string | null
  email: string | null
  phone: string
  grade: string | null
  apiKey: string | null
  apiSecret: string | null
  apiPassword: string | null
  apiKeySpot: string | null
  apiSecretSpot: string | null
  bscDepositWalletAddress: string
  bscWithdrawWalletAddress: string | null
  trcDepositWalletAddress: string
  trcWithdrawWalletAddress: string | null
  usdtBalance: string
  pointBalance: string
  profileImageUrl: string | null
  isAdmin: number
  serviceAt: string | null
  referralAt: string | null
  subscriptionAt: string | null
  parentId: number | null
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
  // ✅ 여기: 단일 객체 → 배열
  trading: TradingInfo[] // <- 변경
  spot: SpotInfo[] // ✅ 단일 → 배열
}

export const authState = atom<AuthState>({
  key: 'authState',
  default: {
    id: null,
    account: '',
    username: '',
    nickname: null,
    email: null,
    phone: '',
    grade: null,
    apiKey: null,
    apiSecret: null,
    apiPassword: null,
    apiKeySpot: null,
    apiSecretSpot: null,
    bscDepositWalletAddress: '',
    bscWithdrawWalletAddress: null,
    trcDepositWalletAddress: '',
    trcWithdrawWalletAddress: null,
    usdtBalance: '0',
    pointBalance: '0',
    profileImageUrl: null,
    isAdmin: 0,
    serviceAt: null,
    referralAt: null,
    subscriptionAt: null,
    parentId: null,
    createdAt: '',
    updatedAt: null,
    deletedAt: null,
    // ✅ 배열이므로 기본값도 []
    trading: [],
    spot: []
  }
})
